/**
 * Whether the second password field should say "De to passwords er ikke ens.": something is typed and
 * it is not the password. While the volunteer is still typing, a repeat that is only the beginning of
 * the password says nothing; once the field has been left it is judged as it stands.
 */
export function repeatMismatch(password, repeat, fieldLeft) {
    if (repeat.length === 0 || repeat === password)
        return false;
    return fieldLeft || !password.startsWith(repeat);
}
